import _taggedTemplateLiteral from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _templateObject, _templateObject2, _templateObject3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _decorate from "@babel/runtime/helpers/esm/decorate";

var _2 = function _2(t) {
  return t;
},
    _t,
    _t2,
    _t3;
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */


import { classMap } from 'lit-html/directives/class-map';
import { html, property, customElement, LitElement, query } from 'lit-element';
import settings from 'carbon-components/es/globals/js/settings';
import ifNonNull from '../../globals/directives/if-non-null';
import FocusMixin from '../../globals/mixins/focus';
import styles from "./link.css.js";
var prefix = settings.prefix;
/**
 * Link size.
 */

export var LINK_SIZE;
/**
 * Link.
 * @element bx-link
 * @csspart link The link.
 */

(function (LINK_SIZE) {
  LINK_SIZE["REGULAR"] = "";
  LINK_SIZE["SMALL"] = "sm";
  LINK_SIZE["LARGE"] = "lg";
})(LINK_SIZE || (LINK_SIZE = {}));

var BXLink = _decorate([customElement("".concat(prefix, "-link"))], function (_initialize, _FocusMixin) {
  var BXLink = /*#__PURE__*/function (_FocusMixin2) {
    _inherits(BXLink, _FocusMixin2);

    var _super = _createSuper(BXLink);

    function BXLink() {
      var _this;

      _classCallCheck(this, BXLink);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _initialize(_assertThisInitialized(_this));

      return _this;
    }

    return BXLink;
  }(_FocusMixin);

  return {
    F: BXLink,
    d: [{
      kind: "field",
      decorators: [query('#link')],
      key: "_linkNode",
      value: void 0
    }, {
      kind: "get",
      key: "_classes",
      value:
      /**
       * The CSS class list for the link node.
       */
      function _classes() {
        var _classMap;

        var disabled = this.disabled,
            size = this.size;
        return classMap((_classMap = {}, _defineProperty(_classMap, "".concat(prefix, "--link"), true), _defineProperty(_classMap, "".concat(prefix, "--link--disabled"), disabled), _defineProperty(_classMap, "".concat(prefix, "--link--").concat(size), size), _classMap));
      }
      /**
       * Handles `click` event on the `<a>`.
       */
      // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars

    }, {
      kind: "method",
      key: "_handleClick",
      value: function _handleClick(_) {}
      /**
       * @returns The inner content.
       */
      // eslint-disable-next-line class-methods-use-this

    }, {
      kind: "method",
      key: "_renderInner",
      value: function _renderInner() {
        return html(_t || (_t = _2(_templateObject || (_templateObject = _taggedTemplateLiteral([" <slot></slot> "])))));
      }
      /**
       * @returns The disabled link content.
       */

    }, {
      kind: "method",
      key: "_renderDisabledLink",
      value: function _renderDisabledLink() {
        var classes = this._classes;
        return html(_t2 || (_t2 = _2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([" <p id=\"link\" part=\"link\" class=\"", "\">", "</p> "])), 0, 0)), classes, this._renderInner());
      }
      /**
       * @returns The link content.
       */

    }, {
      kind: "method",
      key: "_renderLink",
      value: function _renderLink() {
        var download = this.download,
            href = this.href,
            hreflang = this.hreflang,
            linkRole = this.linkRole,
            ping = this.ping,
            rel = this.rel,
            target = this.target,
            type = this.type,
            classes = this._classes,
            handleClick = this._handleClick;
        return html(_t3 || (_t3 = _2(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([" <a id=\"link\" role=\"", "\" class=\"", "\" part=\"link\" download=\"", "\" href=\"", "\" hreflang=\"", "\" ping=\"", "\" rel=\"", "\" target=\"", "\" type=\"", "\" @click=\"", "\"> ", " </a> "])), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), ifNonNull(linkRole), classes, ifNonNull(download), ifNonNull(href), ifNonNull(hreflang), ifNonNull(ping), ifNonNull(rel), ifNonNull(target), ifNonNull(type), handleClick, this._renderInner());
      }
      /**
       * `true` if the button should be disabled.
       */

    }, {
      kind: "field",
      decorators: [property({
        type: Boolean,
        reflect: true
      })],
      key: "disabled",
      value: function value() {
        return false;
      }
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "download",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "href",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "hreflang",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'link-role'
      })],
      key: "linkRole",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "ping",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "rel",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "size",
      value: function value() {
        return LINK_SIZE.REGULAR;
      }
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "target",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "type",
      value: void 0
    }, {
      kind: "method",
      key: "createRenderRoot",
      value:
      /**
       * The default file name.
       */

      /**
       * Link `href`.
       */

      /**
       * The language of what `href` points to.
       */

      /**
       * The a11y role for `<a>`.
       */

      /**
       * URLs to ping.
       */

      /**
       * The link type.
       */

      /**
       * Link size.
       */

      /**
       * The link target.
       */

      /**
       * MIME type of the `target`.
       */
      function createRenderRoot() {
        var _$exec;

        return this.attachShadow({
          mode: 'open',
          delegatesFocus: Number(((_$exec = /Safari\/(\d+)/.exec(navigator.userAgent)) !== null && _$exec !== void 0 ? _$exec : ['', 0])[1]) <= 537
        });
      }
    }, {
      kind: "method",
      key: "render",
      value: function render() {
        var disabled = this.disabled;
        return disabled ? this._renderDisabledLink() : this._renderLink();
      }
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value: function value() {
        return styles;
      }
    }]
  };
}, FocusMixin(LitElement));

export default BXLink;